import * as types from "../../store/mutation-types";
import { login, activate, profile, logout } from "../../store/api/api";

const state = {
  supplier_token: undefined,
  supplier_profile: undefined,
  firebase_confirmation: undefined,

  data_login: {},
  data_activate: {},
  profile_supplier: {},
  authenticate_type: ""
};
/* eslint-disable */
const getters = {
  supplierToken: state => state.supplier_token,
  supplierProfile: state => state.supplier_profile,
  firebaseConfirmation: state => state.firebase_confirmation,

  data_login: state => state.data_login,
  authenticate_type: state => state.authenticate_type
};
const actions = {
  driverLogin({ commit }, data) {
    return new Promise((resolve, reject) => {
      login(data)
        .then(response => {
          if (response) {
            commit(types.SET_DATA_LOGIN, response);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  driverActivate({ commit }, data) {
    return new Promise((resolve, reject) => {
      activate(data)
        .then(response => {
          if (response) {
            commit(types.SET_DATA_ACTIVATE, response);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  getProfile({ commit }, token) {
    return new Promise((resolve, reject) => {
      profile({ token: token }).then(response => {
          if (response) {
            commit(types.SET_SUPPLIER_PROFILE, response.data.supplier);
            resolve(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  logout({ commit }, token) {
    return new Promise((resolve, reject) => {
      logout({ token: token })
        .then(response => {
          if (response) {
            commit(types.SET_SUPPLIER_TOKEN, null);
            commit(types.SET_SUPPLIER_PROFILE, null);
            resolve(response);
          } 
        })
        .catch(err => {
          reject(err);
        });
    });
  },


  setAuthenticateType({ commit }, value) {
    commit(types.SET_AUTHENTICATE_TYPE, value);
  },
  
  setFirebaseConfirmation({ commit }, value) {
    commit(types.SET_FIREBASE_CONFIRMATION, value);
  },

  setSupplierToken({ commit }, value) {
    commit(types.SET_SUPPLIER_TOKEN, value);
  },
  setSupplierProfile({ commit }, value) {
    commit(types.SET_SUPPLIER_PROFILE, value);
  }
};
const mutations = {
  [types.SET_SUPPLIER_TOKEN](state, data) {
    state.supplier_token = data;
  },
  [types.SET_SUPPLIER_PROFILE](state, data) {
    state.supplier_profile = data;
  },
  [types.SET_FIREBASE_CONFIRMATION](state, data) {
    state.firebase_confirmation = data;
  },

  [types.SET_DATA_LOGIN](state, data) {
    state.data_login = data;
  },
  [types.SET_AUTHENTICATE_TYPE](state, value) {
    state.authenticate_type = value;
  },
  [types.SET_DATA_ACTIVATE](state, data) {
    state.data_activate = data;
  },
  [types.SET_DATA_PROFILE](state, data) {
    state.supplier_profile = data;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
